import { render, staticRenderFns } from "./ConsoleAdminStep.vue?vue&type=template&id=b108c08e&scoped=true&"
import script from "./ConsoleAdminStep.vue?vue&type=script&lang=js&"
export * from "./ConsoleAdminStep.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleAdminStep.vue?vue&type=style&index=0&id=b108c08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b108c08e",
  null
  
)

export default component.exports